export enum GenderKeys {
  BOY = 'boy',
  GIRL = 'girl',
}

export const GenderCodes: Record<GenderKeys, number> = {
  [GenderKeys.BOY]: 1,
  [GenderKeys.GIRL]: 2,
};
